import CitySEOHead from "@/components/feature/CitySEOHead";
import MaconHeroSection from "./components/HeroSection";
import MaconStickyNav from "./components/StickyNav";
import MaconProcessingTimeSection from "./components/ProcessingTimeSection";
import MaconServicesSection from "./components/ServicesSection";
import MaconLocalAreaSection from "./components/LocalAreaSection";
import MaconTestimonialsSection from "./components/TestimonialsSection";
import MaconAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import MaconComparisonSection from "./components/ComparisonSection";
import MaconMistakesSection from "./components/MistakesSection";
import MaconHowItWorksSection from "./components/HowItWorksSection";
import MaconFAQSection, { faqs } from "./components/FAQSection";
import MaconHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import MaconFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const maconServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function MaconPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Macon"
        state="Georgia"
        stateAbbr="GA"
        route="/macon"
        title="Emergency Passport Macon, GA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Macon, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Middle Georgia travelers. Get your emergency passport fast!"
        geoPlacename="Macon, Georgia"
        geoPosition="32.8407;-83.6324"
        faqs={faqs}
        servicesSchema={maconServices}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
        keywords="expedited passport, emergency passport, Macon passport, same day passport Macon, fast passport Middle Georgia, Bibb County passport"
      />
      <MaconHeroSection />
      <MaconStickyNav />
      <MaconProcessingTimeSection />
      <MaconServicesSection />
      <MaconLocalAreaSection />
      <MaconTestimonialsSection />
      <MaconAcceptanceFacilitiesSection />
      <MaconComparisonSection />
      <MaconMistakesSection />
      <MaconHowItWorksSection />
      <MaconFAQSection />
      <MaconHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/macon" state="GA" />
      <MaconFinalCTA />
    </div>
  );
}